/* LP ARTMIE MIDAS pasta (ARTM130G, zahraničie) — pri výbere objemu prepne hlavnú fotku galérie na fotku daného balenia.
   Index fotky nesie pilulka v data-imgidx (featured_image variantu); prepína sa klikom na príslušný náhľad,
   takže animácia aj stav galérie idú cez lp-butter JS. Pri programovom kliku sa potláča scrollIntoView
   náhľadu (na mobile by posunul celú stránku), pri načítaní sa prepína len pri odkaze s ?variant=. */
(function () {
  function init() {
    var thumbs = document.querySelectorAll('#lp-thumbs .lp-thumb');
    function klik(t) {
      t.scrollIntoView = function () {};
      t.click();
      delete t.scrollIntoView;
    }
    function ukaz(pill) {
      var i = parseInt(pill.dataset.imgidx, 10);
      if (pill.dataset.avail === '0' || isNaN(i) || !thumbs[i]) return;
      var t = thumbs[i];
      klik(t);
      // galéria počas animácie (~460 ms) ďalší klik ignoruje — pri rýchlom prepínaní to zopakuj
      if (!t.classList.contains('active')) setTimeout(function () {
        if (pill.classList.contains('lp-bundle--active') && !t.classList.contains('active')) klik(t);
      }, 480);
    }
    document.querySelectorAll('.lp-variant-pill[data-imgidx]').forEach(function (p) {
      p.addEventListener('click', function () { ukaz(p); });
    });
    var akt = document.querySelector('.lp-variant-pill.lp-bundle--active[data-imgidx]');
    if (akt && akt.dataset.imgidx !== '0' && /[?&]variant=/.test(location.search)) ukaz(akt);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
